import { useSelector } from 'react-redux';
import { Badge, Button } from '@design-system';
import { Columns3, Settings2, Sparkles, X } from 'lucide-react';
import { selectClient } from '@/model';
import { PoliciesComparisonModal } from '@/features/policies-comparison';
import { EditAssumptionsDialog } from '@/features/edit-assumptions';

interface ShopInsuranceHeaderProps {
  isLoading: boolean;
  error: QuoteError | null;
  onClose: () => void;
}

export function ShopInsuranceHeader({ isLoading, error, onClose }: ShopInsuranceHeaderProps) {
  const client = useSelector(selectClient);
  const hasPolicies = Object.keys(client?.multipleFundingSources?.ltcPolicy ?? {}).length > 0;

  const description = isLoading
    ? 'Loading available insurance quotes...'
    : error !== null
      ? 'No quotes available'
      : 'Compare available insurance quotes';

  return (
    <div className="py-4">
      <div className="flex items-start justify-between">
        <div className="text-left">
          <h1 className="text-primary-dark flex items-center gap-2 text-lg font-semibold md:text-xl">
            Explore Coverage Options
            <Badge>
              <Sparkles />
              BETA
            </Badge>
          </h1>
          <p className="text-foreground text-sm md:text-base">{description}</p>
        </div>
        <div className="flex items-center gap-2">
          <EditAssumptionsDialog>
            <Button
              variant="outline"
              size="sm"
              className="sm:px-3.5! rounded-full"
            >
              <Settings2 />
              <span className="hidden sm:inline">Edit Assumptions</span>
            </Button>
          </EditAssumptionsDialog>
          {hasPolicies && (
            <PoliciesComparisonModal>
              <Button
                variant="outline"
                size="sm"
                className="sm:px-3.5! rounded-full"
              >
                <Columns3 />
                <span className="hidden sm:inline">Compare Policies</span>
              </Button>
            </PoliciesComparisonModal>
          )}
          <Button
            variant="outline"
            size="icon-sm"
            onClick={onClose}
            aria-label="Close"
            className="rounded-full"
          >
            <X />
          </Button>
        </div>
      </div>
    </div>
  );
}
